import "./App.css"; // instead of styles.css

// Definition of App
export default function App() {
  const names = ["Sanjay", "Aniket", "Anjali"];
  const users = [
    {
      name: "Sanjay",
      pic: "https://images.unsplash.com/photo-1618641986557-1ecd230959aa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8aW5zdGFncmFtJTIwcHJvZmlsZXxlbnwwfHwwfHw%3D&w=1000&q=80",
    },

    {
      name: "Aniket",
      pic: "https://bestprofilepictures.com/wp-content/uploads/2021/04/Cool-Profile-Picture.jpg",
    },
    {
      pic: "https://i.pinimg.com/originals/19/cf/78/19cf789a8e216dc898043489c16cec00.jpg",
      name: "Anjali",
    },
  ];
  return (
    <div className="App">
      {/* Clue - Array of objects */}
      {/* <Welcome
        name="Sanjay"
        pic="https://images.unsplash.com/photo-1618641986557-1ecd230959aa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8aW5zdGFncmFtJTIwcHJvZmlsZXxlbnwwfHwwfHw%3D&w=1000&q=80"
      />
      <Welcome
        name="Aniket"
        pic="https://bestprofilepictures.com/wp-content/uploads/2021/04/Cool-Profile-Picture.jpg"
      />
      <Welcome
        name="Anjali"
        pic="https://i.pinimg.com/originals/19/cf/78/19cf789a8e216dc898043489c16cec00.jpg"
      /> */}

      {/* {users.map((user) => (
        <Welcome name={user.name} pic={user.pic} />
      ))} */}

      {users.map(({ name, pic }) => (
        <Welcome name={name} pic={pic} />
      ))}

      {/* <Msg name="Sanjay" />
      <Msg name="Aniket" />
      <Msg name="Anjali" /> */}

      {/* {names.map((name) => (
        <Msg name={name} />
      ))} */}
    </div>
  );
}
// map method -> Transforms -> Array of strings -> Array of components/JSX

// 1. Capital letter - App
// 2. Return JSX
function Msg({ name }) {
  // const name = "Sanjay";
  // console.log(props);
  // const { pic, name } = props;
  return (
    <div>
      <p className="user-name">Hello {name} 👋!!! 😁</p>
    </div>
  );
}

// props
function Welcome({ pic, name }) {
  // const name = "Sanjay";
  // console.log(props);
  // const { pic, name } = props;
  return (
    <div>
      <img src={pic} alt={name} className="user-pic" />
      <p className="user-name">Hello {name} 👋!!! 🤩</p>
    </div>
  );
}

// Task
// 1. Display a profile pic & name
// 2. Use destructuring
// 3. Local app

// function Welcome() {
//   const name = "Sanjay";
//   return (
//     <div>
//       <p className="user-name">Hello {name} 👋!!! 😁</p>
//     </div>
//   );
// }

// JSX - Javascript XML
// JSX -> JS

// class - Resvered keyword
// className - camelCase

// 1. functional component
// 2. Class component

// App is functional component

// Template syntax/ Interpolation (subtitution)
